module.exports = __webpack_public_path__ + "img/phone_white.29a9cb9a.svg";